// extracted by mini-css-extract-plugin
export default {"root":"_3Ulhk","expanded":"_1RgYJ"};